import { DEFAULT_EXPORT_LAYERS } from './exportLayers';

// Initial state shape for a brand-new project (used by "Create New Project").
// Matches the field set serialized by utils/payloadFormatter.js#buildProjectPayload
// so a fresh project can round-trip through save -> load with no surprises.
export const DEFAULT_PROJECT_STATE = {
  unit: 'ft',
  pixelsPerUnit: null,

  polygon: {
    points: [],
    color: '#000000',
    lineWeight: 2,
    lineOpacity: 0.7,
    opacity: 0.7,
    showLayer: false,
    showFill: false,
    showPoints: false,
    showLines: true,
    showCenterPoint: false,
  },

  measurements: {
    items: [],
    lineColor: '#000000',
    lineWeight: 2,
    labelColor: '#000000',
  },

  compass: {
    center: null,
    rotation: 0,
    opacity: 0.7,
    lineOpacity: 0.7,
    lineWeight: 2,
    color: '#000000',
    showCompass: false,
    showCompassLines: true,
    showSectorAreas: true,
    show32Directions: false,
    lines: [],
    angleInputs: [],
  },

  grid: {
    showGrid: false,
    opacity: 0.7,
    ratioX: 1,
    ratioY: 1,
  },

  rooms: {
    roomLayers: [],
  },

  entrance: {
    entrancePoints: [],
    entranceData: null,
  },

  layers: {
    exportLayers: DEFAULT_EXPORT_LAYERS,
    savedLayerConfigs: {},
    layerImages: {},
  },

  coverPage: {
    clientDetails:    { name: '', phone: '', email: '', propertyType: '', address: '', dateOfVisit: '' },
    consultantDetails: { name: '', phone: '', email: '', address: '' },
    selected45Block: null,
    footerText: '',
  },
};

// Build a fresh meta block (project envelope) for a new project before it has an id.
export const newProjectMeta = (name = 'Untitled Project') => ({
  id: null,
  name,
  floorPlanRef: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
});
